<ng-container *ngIf="permissionsMap[PermissionKeys.SCHEDULE_READ]; else permissionNotAvailable">
  @if (isAWS) {
  <div class="flex flex-col items-center justify-center pt-8 pb-10 mt-100 fs-16">
    <mat-icon svgIcon="report_problem" class="icon-md-2 h-50 w-50 not-supported"></mat-icon>
    <div class="mt-10 feature-not-avaliable">{{'FEATURE.FEATURE_NOT_SUPPORTED_FOR_AWS' | transloco}}</div>
  </div>
  } @else {
  <div class="flex ml-72 mr-72 mt-20 items-center justify-between header-section">
    <div class="flex items-center">
      <mat-icon svgIcon="manage_history" class="icon-lg mr-4"></mat-icon>
      <div class="mat-subtitle-2 mb-0 fs-24 fw-600 ml-2">{{'SCHEDULES.SCHEDULES' | transloco}}<span class="ml-2" *ngIf="!schedulesLoading">
        ({{searchTerm?.length > 0 && searchedResult ? searchedResult.length : schedules?.length}})
      </span></div>
      <div class="ml-16 search-scheduler">
        <app-search-filter *ngIf="initialSchedules?.length > 0" class="mt-20 ml-20" placeholder="SEARCH.SEARCH" (changed)="search($event)"></app-search-filter>
      </div>
      <div *ngIf="initialSchedules?.length > 0" class="vertical-dash ml-12 mr-12"></div>
        <div>
          <button *ngIf="initialSchedules?.length > 0" class="flex justify-center items-center schedule-filter pl-6 pr-16 h-34" (click)="filterColumns()">
            <mat-icon class="mr-4" svgIcon="filter_alt"></mat-icon>
            <span class="mat-body-1 fw-500">{{'SOLUTIONS.FILTERS' | transloco }}</span>
          </button>
        </div>
    </div>
    <div class="flex flex-row gap-3">
      <button *ngIf="selectedData?.status === 'active' && permissionsMap[PermissionKeys.SCHEDULE_UPDATE]" type="submit" class="flex disable h-32 fw-700 place-items-center" (click)="onDisableSchedule()"><mat-icon svgIcon="block" class="mr-4 icon-sm"></mat-icon>{{'BUTTONS.DISABLE' | transloco}}</button>
      <button *ngIf="selectedData?.status === 'disabled' && permissionsMap[PermissionKeys.SCHEDULE_UPDATE]" type="submit" class="flex enable h-32 fw-700 place-items-center" (click)="onEnableSchedule()"><mat-icon svgIcon="check" class="mr-4 icon-sm"></mat-icon>{{'BUTTONS.ENABLE' | transloco}}</button>
      <button *ngIf="!schedulesLoading && initialSchedules?.length > 0 && permissionsMap[PermissionKeys.SCHEDULE_DELETE]" [ngClass]="{'disabled': !editEnable || selectedData?.status === 'deleted' || selectedData?.status === 'disabled'}" type="submit" class="flex delete h-32 fw-700 place-items-center" (click)="onDeleteSchedule()"><mat-icon svgIcon="delete" class="mr-4 icon-sm"></mat-icon>{{'BUTTONS.DELETE' | transloco}}</button>
      <div *ngIf="!schedulesLoading && initialSchedules?.length > 0 && permissionsMap[PermissionKeys.SCHEDULE_UPDATE]" [ngClass]="{'disabled': !editEnable || selectedData?.status === 'deleted' || selectedData?.status === 'completed'}" class="flex mr-16 justify-end cursor-pointer edit-border items-center" (click)="editSchedule()">
          <mat-icon svgIcon="edit" class="icon-sm mr-4 edit-design"></mat-icon>
          <div class="flex items-center fs-20 fs-16 fw-500">{{ 'BUTTONS.EDIT' | transloco | titlecase}}</div>
      </div>
      <div *ngIf="!schedulesLoading && initialSchedules?.length > 0 && (permissionsMap[PermissionKeys.SCHEDULE_DELETE] || permissionsMap[PermissionKeys.SCHEDULE_UPDATE])" class="flex items-center border-left mr-16"></div>
      <div class="flex items-center mr-16">
          <button *ngIf="!schedulesLoading && initialSchedules?.length > 0 && permissionsMap[PermissionKeys.SCHEDULE_CREATE]" type="submit" class="flex accent h-32" (click)="onCreateNewSchedule()"><mat-icon svgIcon="add" class="mt-6 mr-6 icon-sm"></mat-icon>{{'BUTTONS.CREATE' | transloco}}</button>
      </div>
      <div *ngIf="!schedulesLoading && initialSchedules?.length > 0 && permissionsMap[PermissionKeys.SCHEDULE_CREATE]" class="flex items-center border-left mr-16"></div>
        <div *ngIf="!schedulesLoading && initialSchedules?.length > 0" class="refresh-circle rounded-full w-32 h-32 flex items-center justify-center cursor-pointer" (click)="refreshClick()">
            <mat-icon svgIcon="refresh" class="icons transition-transform duration-700" [ngClass]="{ 'animate-spin': isRefreshing }"></mat-icon>
        </div>
    </div>
  </div>
  <div *ngIf="initialSchedules?.length > 0" class="flex flex-row items-center mt-8 ml-72">
    @if (selectedStatus?.length > 0) {
      <span class="pr-8 fs-16">{{ 'TOOLBAR.STATUS' | transloco }}</span>
    }
    <div class="mr-4 pt-8 pb-4 filtered-items flex items-center fs-16 fw-500" *ngIf="selectedStatus?.length > 0">
      <span *ngFor="let status of selectedStatus" class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-16">
        {{getStatusLabel(status)}}
        <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="cancelStatusFilter(status)"></mat-icon>
      </span>
    </div>
    @if (selectedTriggers?.length > 0) {
      <span class="pr-8 fs-16">{{ 'TOOLBAR.TRIGGERS' | transloco }}</span>
    }
    <div class="mr-4 pt-8 pb-4 filtered-items flex items-center fs-16 fw-500" *ngIf="selectedTriggers?.length > 0">
      <span *ngFor="let datazone of selectedTriggers" class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-16">
        {{datazone | titlecase}}
        <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="cancelTriggerFilter(datazone)"></mat-icon>
      </span>
    </div>
    @if (selectedDate?.length > 0 && !(selectedDate?.length === 1 && selectedDate.includes('Next 2 hours'))) {
      <span class="pr-8 fs-16">{{'SCHEDULES.SCHEDULED_DATE' | transloco}}:</span>
    }
    <div class="mr-4 pt-8 pb-4 filtered-items flex items-center fs-16 fw-500" *ngIf="selectedDate?.length > 0">
      <span *ngFor="let date of selectedDate" class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-16">
      {{ date!=="Next 2 hours" && filterStartDate && filterEndDate  ? datePipe.transform(filterStartDate, 'dd MMM yyyy')+ ' - ' + datePipe.transform(filterEndDate, 'dd MMM yyyy') : date}}
        <span class="ml-8">
          <mat-icon svgIcon="close" class="cursor-pointer icon-sm" (click)="cancelScheduleDateFilter(date)"></mat-icon>
        </span>
      </span>
    </div>
    <div class="flex flex-row items-center">
      <span *ngIf="selectedTriggers?.length > 0 || selectedStatus?.length > 0 || (filterStartDate && filterEndDate) || selectedDate?.length > 0" class="flex justify-center items-center mat-subtitle-2 mb-0 fw-500 cursor-pointer warn-solid-fg" (click)="resetScheduleFilter()">
        {{ 'BUTTONS.CLEAR_ALL' | transloco }}
      </span>
    </div>
  </div>
  <mat-divider *ngIf="!schedulesLoading" class="neutral-2 mt-12 ml-72 mr-72"></mat-divider>
  <div class="ml-72 mr-72 schedule-container mb-32">
    <div class="pt-16">
      <div *ngIf="schedulesLoading" class="flex spinner-container spinner">
        <mat-spinner diameter="24"
          color="primary"
          mode="indeterminate">
        </mat-spinner>
      </div>
      <app-table (approve)="getApproveData($event)" [ngClass]="{'disabled': showLoader}" [initialDataSource]="schedules" [displayColumns]="displayColumns" [dataLoading]="schedulesLoading" [showSkeletonLoader]="false" [searchTerm]="searchTerm" [dataSourceLength]="true" page="schedule"  [pageName]="pageName" [initialCreate]="initialSchedules?.length === 0" (searchedResults)="searchedItems($event)"></app-table>
      <div *ngIf="!schedulesLoading && initialSchedules?.length === 0  && permissionsMap[PermissionKeys.SCHEDULE_CREATE]" class="flex flex-col justify-center items-center mb-30 common-table">
        <span class="fw-500 fs-16 mt-40">{{'SCHEDULES.NO_SCHEDULE' | transloco}}</span>
        <button type="submit" class="flex accent h-32 mt-16 mb-80" (click)="onCreateNewSchedule()"><mat-icon svgIcon="add" class="mr-10 mt-6 icon-sm"></mat-icon>{{'BUTTONS.CREATE' | transloco}}</button>
      </div>
    </div>
  </div>
  <div *ngIf="showLoader">
    <mat-card class="flex spinner-container load-spinner">
      <mat-spinner diameter="24"
        color="primary"
        mode="indeterminate">
      </mat-spinner>
    </mat-card>
  </div>
  }
</ng-container>
<ng-template #permissionNotAvailable>
  <div class="flex flex-col items-center no-permission justify-center ml-60 mr-60 pb-100 pt-100 mt-32 fs-16">
    <img src="/assets/images/no_access_schedule.png"> 
    <div class="mt-10 feature-not-avaliable">{{'SCHEDULE_DETAILS.NO_ACCESS' | transloco}}</div>
  </div>
</ng-template>